import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'nova-match-category-description',
    templateUrl: './match-category-description.component.html',
    styleUrls: ['./match-category-description.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class MatchCategoryDescriptionComponent {
    @Input() matchCategory: string | undefined;
    @Input() dataQaId?: string = 'match-category-description';
}
